/* eslint-disable */

import { object } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

/* ----------------------------------------------------
 * Simulation
 * -------------------------------------------------- */

const SIM = {
    day: "day1",
    min: 15 * 60 + 20,
};

/* ----------------------------------------------------
 * Room mapping
 * -------------------------------------------------- */

const ROOM_MAP = {
    "b3e1ee1-c0f3-83a4-dfac-f858c8d50357":
        "Convention Center",

    "4c5a631-5156-fce8-fc0-e758f7b41846":
        "Scarlet 1 Ballroom",

    "cf8cd-a84b-aadd-cfd0-15674677c2c":
        "Zinnia Hall",
};

/* ----------------------------------------------------
 * Breakout time slots
 * -------------------------------------------------- */

const BREAKOUT_SLOTS = [
    {
        start: "11:45",
        end: "12:45",
    },
    {
        start: "13:45",
        end: "14:45",
    },
    {
        start: "15:00",
        end: "16:00",
    },
    {
        start: "16:15",
        end: "17:15",
    },
];

/* ----------------------------------------------------
 * Helpers
 * -------------------------------------------------- */

const toMin = (time) => {
    if (!time) return 0;

    const parts = time.split(":");

    return +parts[0] * 60 + +parts[1];
};

const getTimeOnly = (dateTime) => {
    if (!dateTime) return "";

    /*
     * Example:
     * 2026-10-13 10:25
     *
     * returns:
     * 10:25
     */

    const parts = dateTime.split(" ");

    return parts[1] || dateTime;
};

const t12 = (dateTime) => {
    const time = getTimeOnly(dateTime);

    if (!time) return "";

    const p = time.split(":");

    let h = +p[0];

    const ap = h >= 12 ? "PM" : "AM";

    h = h % 12 || 12;

    return (
        (h < 10 ? "0" : "") +
        h +
        ":" +
        p[1] +
        " " +
        ap
    );
};

const getStatus = (session) => {
    if (!session?.startTime || !session?.endTime) {
        return null;
    }

    const now = new Date();

    const start = new Date(session.startTime.replace(" ", "T"));
    const end = new Date(session.endTime.replace(" ", "T"));

    // 1. Live toggle OFF => session LIVE nahi hogi
    if (session.live !== true) {
        // Agar session ka time khatam ho gaya hai to Session Over
        if (now > end) {
            return "Session Over";
        }

        return null;
    }

    // 2. Date check
    const sameDate =
        now.getFullYear() === start.getFullYear() &&
        now.getMonth() === start.getMonth() &&
        now.getDate() === start.getDate();

    if (!sameDate) {
        return null;
    }

    // 3. Start hone se pehle
    if (now < start) {
        return null;
    }

    // 4. Start -> End = LIVE
    if (now <= end) {
        return "live";
    }

    // 5. End ke baad
    return "Session Over";
};

const getSpeakerList = (speakers) => {


    if (!speakers) return [];

    if (Array.isArray(speakers)) {
        return speakers;
    }

    if (typeof speakers === "object") {
        return Object.values(speakers);
    }

    return [];
};

/* ----------------------------------------------------
 * Redux
 * -------------------------------------------------- */

const mapStateToProps = ({
    virtualUser,
    agenda,
    virtualEvent,
}) => ({
    virtualUser,
    agenda,
    virtualEvent,
});

/* ----------------------------------------------------
 * Component
 * -------------------------------------------------- */

@withRouter
@connect(mapStateToProps)
class AwsAgenda extends Component {
    constructor(props) {
        super(props);

        this.state = {
            day: "day1",
            player: null,
        };
    }

    /* ------------------------------------------------
     * Lifecycle
     * ---------------------------------------------- */

    componentDidMount() {
        window.addEventListener(
            "keydown",
            this.onKey
        );
    }

    componentWillUnmount() {
        window.removeEventListener(
            "keydown",
            this.onKey
        );
    }

    /* ------------------------------------------------
     * Keyboard
     * ---------------------------------------------- */

    onKey = (e) => {
        if (e.key === "Escape") {
            this.closePlayer();
        }
    };

    /* ------------------------------------------------
     * Day
     * ---------------------------------------------- */

    setDay = (day) => {
        this.setState({
            day,
        });
    };

    /* ------------------------------------------------
     * Initiate session
     * ---------------------------------------------- */

    initiateSession = (sessionData) => {
        if (!sessionData) return;

        const {
            dispatch,
        } = this.props;

        console.log(
            "sessionData",
            sessionData
        );

        dispatch({
            type: "virtualEvent/FILTER_SCENE",

            payload: {
                id: sessionData?.assignedRoom,

                navigated: true,

                componentRendered: false,

                sessionID: sessionData?.id,

                currentSessionURL:
                    sessionData?.url,
            },
        });
    };

    /* ------------------------------------------------
     * Close player
     * ---------------------------------------------- */

    closePlayer = () => {
        this.setState({
            player: null,
        });
    };

    /* ------------------------------------------------
     * Jump to live session
     * ---------------------------------------------- */

    jumpTo = (e, id) => {
        e.preventDefault();

        const el =
            document.getElementById(id);

        if (el) {
            el.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };

    /* ------------------------------------------------
     * Convert API agendas
     * ---------------------------------------------- */

    getAgendaData = () => {
        const {
            agenda,
        } = this.props;

        const agendas =
            agenda?.agendas;

        if (!agendas) {
            return [];
        }

        /*
         * API:
         *
         * agendas: {
         *   uuid1: {
         *      date,
         *      name,
         *      agendaOrder,
         *      agendaItems: {}
         *   },
         *
         *   uuid2: {
         *      date,
         *      name,
         *      agendaOrder,
         *      agendaItems: {}
         *   }
         * }
         */

        return Object.entries(
            agendas
        )
            .map(
                ([agendaId, agendaData]) => {
                    const agendaItems =
                        Object.entries(
                            agendaData.agendaItems ||
                            {}
                        ).map(
                            ([id, item]) => ({
                                ...item,
                                id,
                                agendaId,
                            })
                        );

                    return {
                        ...agendaData,

                        id: agendaId,

                        agendaItems,
                    };
                }
            )
            .sort(
                (a, b) =>
                    (a.agendaOrder || 0) -
                    (b.agendaOrder || 0)
            );
    };

    /* ------------------------------------------------
     * Selected agenda
     * ---------------------------------------------- */

    getSelectedAgenda = () => {
        const agendas =
            this.getAgendaData();

        const {
            day,
        } = this.state;

        const agendaOrder =
            Number(
                day.replace("day", "")
            );

        return (
            agendas.find(
                (item) =>
                    Number(
                        item.agendaOrder
                    ) === agendaOrder
            ) || agendas[0]
        );
    };

    /* ------------------------------------------------
     * Room name
     * ---------------------------------------------- */

    getRoomName = (roomId) => {
        if (!roomId) {
            return "Main Stage";
        }

        return (
            ROOM_MAP[roomId] ||
            roomId
        );
    };

    /* ------------------------------------------------
     * Play button
     * ---------------------------------------------- */

    renderPlayBtn = (
        st,
        sessionData
    ) => {
        const prefix =
            st === "live"
                ? "Watch live: "
                : st?.toLowerCase() === "session over"
                    ? "Watch recording: "
                    : "Starts later: ";

        const cls =
            "aws-play" +
            (st === "live"
                ? " aws-play-live"
                : st === "soon"
                    ? " aws-play-soon"
                    : "");

        return (
            <button
                type="button"
                className={cls}
                aria-disabled={
                    st === "soon"
                        ? "true"
                        : undefined
                }
                aria-label={
                    prefix +
                    sessionData.title
                }
                onClick={() =>
                    this.initiateSession(
                        sessionData
                    )
                }
            >
                {/* <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M7 4l13 8-13 8z" />
                </svg> */}
                Join Now
            </button>
        );
    };

    /* ------------------------------------------------
     * Status tag
     * ---------------------------------------------- */

    renderTag = (
        st,
        start,
        type
    ) => {
        if (st === "live") {
            return (
                <span className="aws-tag-live" style={{ height: type === 'keynote' && '46px', color: type === 'keynote' && 'white' }}>
                    <i />
                    Live
                </span>
            );
        }

        if (
            st?.toLowerCase() ===
            "session over"
        ) {
            return (
                <span className="aws-tag-red" style={{ height: type === 'keynote' && '46px', color: type === 'keynote' && 'white' }}>
                    Session Over
                </span>
            );
        }

        return null
        // (
        //     <span className="aws-tag-soft">
        //         {t12(start)}
        //     </span>
        // );
    };

    /* ------------------------------------------------
     * Speakers
     * ---------------------------------------------- */

    renderSpeakers = (speakers) => {
    const list = getSpeakerList(speakers);

    if (!list.length) {
        return (
            <span className="aws-no-speakers">
                Speakers to be announced
            </span>
        );
    }

    return (
        <div className="avs">
            {list.map((speaker, index) => {
                const name = speaker?.speakerName || "Speaker";
                const initials = name
                    .trim()
                    .split(/\s+/)
                    .slice(0, 2)
                    .map(word => word.charAt(0))
                    .join("")
                    .toUpperCase();

                return (
                    <div
                        className="keynote-speaker-item"
                        key={`${name}-${index}`}
                    >
                        <div className="keynote-speaker-avatar">
                            {/* {speaker?.imageUrl ? (
                                <img
                                    src={speaker.imageUrl}
                                    alt={name}
                                />
                            ) : (
                                initials
                            )} */}
                            {initials}
                        </div>

                        <div className="keynote-speaker-info">
                            <strong>{name}</strong>

                            {speaker?.smallIntro && (
                                <span>{speaker.smallIntro}</span>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

    /* ------------------------------------------------
     * Agenda
     * ---------------------------------------------- */

    renderAgenda = () => {
        const agendas =
            this.getAgendaData();

        const {
            day,
        } = this.state;

        const selectedAgenda =
            this.getSelectedAgenda();

        if (!selectedAgenda) {
            return (
                <div className="aws-empty">
                    No agenda available
                </div>
            );
        }

        const sessions =
            selectedAgenda.agendaItems ||
            [];

        /*
         * Sort sessions
         */

        const sortedSessions =
            [...sessions].sort(
                (a, b) =>
                    new Date(
                        a.startTime
                    ) -
                    new Date(
                        b.startTime
                    )
            );

        /* --------------------------------------------
         * Main stage / keynote
         * ------------------------------------------ */

        const keynoteSessions =
            sortedSessions.filter(
                (item) =>
                    item?.name?.toLowerCase()?.includes('keynote')
            );

        /* --------------------------------------------
         * Breakout groups
         *
         * breakoutToggle === true
         * AND exact time slot
         * ------------------------------------------ */

        const breakoutGroups =
            BREAKOUT_SLOTS.map(
                (slot) => {
                    const sessions =
                        sortedSessions.filter(
                            (session) => {
                                const start =
                                    getTimeOnly(
                                        session.startTime
                                    );

                                const end =
                                    getTimeOnly(
                                        session.endTime
                                    );

                                return (
                                    session.breakoutToggle ===
                                    true &&
                                    start ===
                                    slot.start &&
                                    end ===
                                    slot.end
                                );
                            }
                        );

                    return {
                        ...slot,
                        sessions,
                    };
                }
            );

        /* --------------------------------------------
         * Live sessions
         * ------------------------------------------ */

        const lives = [];

        /* --------------------------------------------
         * Keynotes
         * ------------------------------------------ */

        const keynotes =
            keynoteSessions.map(
                (session) => {
                    const st = getStatus(session);

                    const id =
                        "aws-kn-" +
                        session.id;

                    if (
                        st === "live"
                    ) {
                        lives.push({
                            id,
                            label:
                                session.title,
                        });
                    }

                    const speakers =
                        getSpeakerList(
                            session.speakers
                        );

                    return (
                        <div
                            key={
                                session.id
                            }
                            id={id}
                            className={
                                "aws-kr" +
                                (st ===
                                    "live"
                                    ? " aws-kr-live"
                                    : "")
                            }
                        >
                            {/* {this.renderPlayBtn(st, session)} */}

                            <time className="aws-kr-time">
                                {t12(
                                    session.startTime
                                )}{" "}
                                –{" "}
                                {t12(
                                    session.endTime
                                )}
                            </time>

                            <div className="aws-kr-title">
                                {
                                    session.title
                                }
                            </div>

                            <div className="aws-kr-who">
                                {this.renderSpeakers(
                                    speakers
                                )}
                            </div>

                            {/* <div className="aws-kr-status">
                                {this.renderTag(
                                    st,
                                    session.startTime
                                )}
                            </div> */}
                        </div>
                    );
                }
            );

        /* --------------------------------------------
         * Breakout slots
         * ------------------------------------------ */

        const slots =
            breakoutGroups.map(
                (group) => {
                    const {
                        start,
                        end,
                        sessions,
                    } = group;

                    /*
                     * If this slot has no
                     * breakout session,
                     * don't render it.
                     */

                    if (
                        !sessions.length
                    ) {
                        return null;
                    }

                    return (
                        <div
                            className="aws-slot"
                            key={`${start}-${end}`}
                        >
                            <div className="aws-slot-head">
                                
                                    {t12(
                                        sessions[0]
                                            .startTime
                                    )}
                                

                                {" – "}

                                {t12(
                                    sessions[0]
                                        .endTime
                                )}
                            </div>

                            <div className="aws-cols">
                                {sessions.map(
                                    (
                                        session,
                                        index
                                    ) => {
                                        const st = getStatus(session);

                                        const id =
                                            "aws-ses-" +
                                            session.id;

                                        if (
                                            st ===
                                            "live"
                                        ) {
                                            lives.push(
                                                {
                                                    id,
                                                    label:
                                                        session.title,
                                                }
                                            );
                                        }

                                        const speakers =
                                            getSpeakerList(
                                                session.speakers
                                            );

                                        return (
                                            <article
                                                key={
                                                    session.id ||
                                                    index
                                                }
                                                id={
                                                    st ===
                                                        "live"
                                                        ? id
                                                        : undefined
                                                }
                                                className={
                                                    "aws-ss" +
                                                    (st ===
                                                        "live"
                                                        ? " aws-ss-live"
                                                        : "")
                                                }
                                            >
                                                <div className="aws-ss-row">
                                                    <span className="aws-room">
                                                        Track{" "}
                                                        {index +
                                                            1}{" "}
                                                        {/* ·{" "}
                                                        {this.getRoomName(
                                                            session.assignedRoom
                                                        ).replace(
                                                            / Ballroom| Hall/,
                                                            ""
                                                        )} */}
                                                    </span>

                                                    {this.renderTag(
                                                        st,
                                                        session.startTime
                                                    )}
                                                </div>

                                                {/* <span className="aws-code">
                                                    {session.code ||
                                                        ""}
                                                </span> */}

                                                <h3 className="aws-ss-name">
                                                    {
                                                        session.title
                                                    }
                                                </h3>

                                                <div className="aws-ss-bottom">
                                                    <div className="aws-ss-speakers">
                                                        {speakers.length
                                                            ? this.renderSpeakers(
                                                                session.speakers
                                                            )
                                                            : "Speakers to be announced"}

                                                        {/* {speakers.length >
                                                            2 &&
                                                            " +" +
                                                            (speakers.length -
                                                                2) +
                                                            " more"} */}
                                                    </div>

                                                    {this.renderPlayBtn(
                                                        st,
                                                        session
                                                    )}
                                                </div>
                                            </article>
                                        );
                                    }
                                )}
                            </div>
                        </div>
                    );
                }
            );

        /* --------------------------------------------
         * Total parallel tracks
         *
         * Maximum number of sessions
         * in any single breakout slot
         * ------------------------------------------ */

        const parallelTracks =
            breakoutGroups.reduce(
                (
                    max,
                    group
                ) =>
                    Math.max(
                        max,
                        group.sessions
                            .length
                    ),
                0
            );

        /* --------------------------------------------
         * Final UI
         * ------------------------------------------ */

        return (
            <>
                {/* Header */}

                <div className="aws-head">
                    <div>
                        {/* <div className="aws-eyebrow">
                            Samriddhi 2026 · Live
                        </div> */}

                        <h1 className="aws-title">
                            Agenda
                        </h1>
                    </div>

                    <div
                        className="aws-days"
                        role="tablist"
                    >
                        {agendas.map(
                            (agenda) => {
                                const dayKey =
                                    `day${agenda.agendaOrder}`;

                                return (
                                    <button
                                        key={
                                            agenda.id
                                        }
                                        role="tab"
                                        aria-selected={
                                            day ===
                                            dayKey
                                        }
                                        className={
                                            "aws-days-btn" +
                                            (day ===
                                                dayKey
                                                ? " aws-days-on"
                                                : "")
                                        }
                                        onClick={() =>
                                            this.setDay(
                                                dayKey
                                            )
                                        }
                                    >
                                        <b>
                                            {
                                                agenda.name
                                            }
                                        </b>

                                        <small>
                                            {new Date(
                                                agenda.date
                                            ).toLocaleDateString(
                                                "en-GB",
                                                {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: 'numeric'
                                                }
                                            )}
                                        </small>
                                    </button>
                                );
                            }
                        )}
                    </div>
                </div>

                {/* Live bar */}

                {/* {lives.length >
                    0 && (
                        <div className="aws-livebar">
                            <span className="aws-tag-live">
                                <i />
                                Live now
                            </span>

                            <b>
                                {
                                    lives.length
                                }{" "}
                                session
                                {lives.length >
                                    1
                                    ? "s"
                                    : ""}{" "}
                                streaming
                            </b>

                            <span className="aws-livebar-links">
                                {lives.map(
                                    (
                                        live
                                    ) => (
                                        <a
                                            key={
                                                live.id
                                            }
                                            href={
                                                "#" +
                                                live.id
                                            }
                                            onClick={(
                                                e
                                            ) =>
                                                this.jumpTo(
                                                    e,
                                                    live.id
                                                )
                                            }
                                        >
                                            {
                                                live.label
                                            }
                                        </a>
                                    )
                                )}
                            </span>
                        </div>
                    )} */}

                {/* Keynotes */}

                <div className="aws-sec-title aws-keynote-header">
                    <div className="aws-keynote-heading">
                        <h2>Keynote Sessions</h2>
                    </div>

                    {keynoteSessions.length > 0 && (() => {
                        const currentKeynote = keynoteSessions.find(
                            session => getStatus(session) === "live"
                        ) || keynoteSessions[0];

                        const status = getStatus(currentKeynote);

                        return (
                            <div className="aws-keynote-actions">
                                {/* {status && ( */}
                                    <button
                                        type="button"
                                        className="aws-play aws-play-live"
                                        onClick={() => this.initiateSession(currentKeynote)}
                                    >
                                        Join Now
                                    </button>
                                {/* )} */}

                                {this.renderTag(
                                    status,
                                    currentKeynote.startTime,
                                    'keynote'
                                )}
                            </div>
                        );
                    })()}
                </div>

                <div className="aws-kn">
                    {keynotes}
                </div>

                {/* Breakouts */}

                <div className="aws-sec-title">
                    <h2>
                        Breakout sessions
                    </h2>

                    {/* <span>
                        {parallelTracks}{" "}
                        parallel{" "}
                        {parallelTracks ===
                            1
                            ? "track"
                            : "tracks"}
                    </span> */}
                </div>

                {slots}
            </>
        );
    };

    /* ------------------------------------------------
     * Render
     * ---------------------------------------------- */

    render() {
        const agendas =
            this.getAgendaData();

        if (!agendas.length) {
            return (
                <div className="aws-empty">
                    Loading agenda...
                </div>
            );
        }

        return (
            <>
                {this.renderAgenda()}
            </>
        );
    }
}

export default AwsAgenda;